import { importProvidersFrom, NgModule, provideAppInitializer } from '@angular/core';
import {BrowserModule, HammerGestureConfig, HammerModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from '@theme/shared/shared.module';
import {AdminComponent} from '@theme/layout/admin/admin.component';
import {NavBarComponent} from '@theme/layout/admin/nav-bar/nav-bar.component';
import {NavigationComponent} from '@theme/layout/admin/navigation/navigation.component';
import {NavLeftComponent} from '@theme/layout/admin/nav-bar/nav-left/nav-left.component';
import {NavRightComponent} from '@theme/layout/admin/nav-bar/nav-right/nav-right.component';
import {NavContentComponent} from '@theme/layout/admin/navigation/nav-content/nav-content.component';
import {NavLogoComponent} from '@theme/layout/admin/navigation/nav-logo/nav-logo.component';
import {NavGroupComponent} from '@theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import {NavItemComponent} from '@theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import {NavSearchComponent} from '@theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import {NavigationItem} from '@theme/layout/admin/navigation/navigation';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {TokenInterceptor} from "./core/interceptors/token.interceptor";
import {ErrorInterceptor} from "./core/interceptors/error.interceptor";
import {NgxPermissionsModule} from "ngx-permissions";
import {
  NbCardModule,
  NbDatepickerModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbThemeModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import {NbEvaIconsModule} from "@nebular/eva-icons";
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask'
import {NgxSpinnerModule} from "ngx-spinner";
import {NgSelectModule} from "@ng-select/ng-select";
import {ThemeModule} from "@theme/theme.module";
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule, MatOptionModule} from '@angular/material/core';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MethodsUtils} from "@shared/utils/methods.utils";
import {GuestComponent} from "@theme/layout/guest/guest.component";
import {CoreModule} from "@shared/core.module";
import {MatInputModule} from "@angular/material/input";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSelectModule} from "@angular/material/select";
import { ServiceWorkerModule } from "@angular/service-worker";
import { initializeApp } from "firebase/app";
import {environment} from "@env";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatDividerModule} from "@angular/material/divider";
import {MatSidenavModule} from '@angular/material/sidenav';
import { MobileMenuItemComponent } from '@theme/layout/admin/mobile-menu/mobile-menu-item/mobile-menu-item.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { TranslateModule, provideTranslateLoader } from '@ngx-translate/core';
initializeApp(environment.firebase);
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { initializeDirectionFactory } from '@shared/directives/initialize-direction.factory';
import { LanguageInterceptor } from '@shared/interceptors/LanguageInterceptor.interceptor';
import * as Hammer from 'hammerjs';
export class CustomHammerConfig extends HammerGestureConfig {
  override overrides = {
    swipe: {
      direction: Hammer.DIRECTION_HORIZONTAL,
      velocity: 0.1, // Minimum velocity for a swipe
      threshold: 10, // Minimum movement for a swipe
    },
  };
}

@NgModule({

  declarations: [
    AppComponent,
    AdminComponent,
    GuestComponent,
    NavBarComponent,
    NavigationComponent,
    NavLeftComponent,
    NavRightComponent,
    NavContentComponent,
    NavLogoComponent,
    NavGroupComponent,
    NavItemComponent,
    NavSearchComponent,
    MobileMenuItemComponent,
  ],
  exports: [MatDatepickerModule],
    imports: [
      HammerModule,
        NgOtpInputModule,
        MatDatepickerModule,
        BrowserModule,
        AppRoutingModule,
        MatButtonModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatMomentDateModule,
        NgSelectModule,
        ThemeModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NgxSpinnerModule,
        NbCardModule,
        NbThemeModule.forRoot({name: 'default'}),
        HttpClientModule,
        TranslateModule.forRoot({
          loader: provideTranslateLoader(TranslateHttpLoader),
        }),
        
        NbInputModule,
        MatDividerModule,
        NbWindowModule.forRoot({
            buttons: {
                minimize: false,
                maximize: false,
                fullScreen: false,
                close: true,
            },
            hasBackdrop: false,
            closeOnBackdropClick: false,
            windowClass: 'custom-window',
        }),
        NbLayoutModule,
        NbToastrModule.forRoot(),
        NbEvaIconsModule,
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NgxPermissionsModule.forRoot(),
        NbLayoutModule,
        NgxPermissionsModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        BrowserAnimationsModule,
        CoreModule,
        NbFormFieldModule,
        NbIconModule,
        MatInputModule,
        NgxMaskDirective,
        MatTooltipModule,
        MatOptionModule,
        MatSelectModule,
      MatSnackBarModule,
      MatSidenavModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        // Only enable in production so dev deployments always show latest changes
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ],

  providers: [
    MethodsUtils,
    provideNgxMask(),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json',
        enforceLoading: false,
        useHttpBackend: false,
      },
    },
    NavigationItem,
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true},
    importProvidersFrom(HammerModule),
    provideAppInitializer(() => {
        const initializerFn = (initializeDirectionFactory)();
        return initializerFn();
      }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
